import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const app = firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSANGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
});

const firestore = app.firestore();

export const db = {
  users: firestore.collection("users"),
  usersGroup: firestore.collectionGroup("users"),
  salaries: firestore.collection("salaries"),
  salariesGroup: firestore.collectionGroup("salaries"),
  nonsalaries: firestore.collection("nonsalaries"),
  nonsalariesGroup: firestore.collectionGroup("nonsalaries"),
  getCurrentTimeStamp: firebase.firestore.FieldValue.serverTimestamp,
  setFromDate: firebase.firestore.Timestamp,
};

export const auth = app.auth();
export default app;
